import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e23bc5aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row",
  style: {"border-radius":"25px","top":"50px"}
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","margin-top":"20px"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "List Bank")
], -1))
const _hoisted_5 = {
  class: "button__item",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_topup_default_bank"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Set Default Bank", -1))
const _hoisted_7 = {
  key: 0,
  class: "card-body-custom"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "media/icons/Group 5905.svg" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Do you want to delete this bank", -1))
const _hoisted_14 = { class: "dialog-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_inline_svg, { width: "18px" }),
              _hoisted_6
            ])
          ]),
          (_ctx.isLoading == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_Datatable, {
                  "table-header": _ctx.tableHeader,
                  "table-data": _ctx.TablebankList,
                  "enable-items-per-page-dropdown": true,
                  currentPage: _ctx.route.query.current_page,
                  rowsPerPage: _ctx.route.query.row_per_page
                }, {
                  "cell-no": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.no), 1)
                  ]),
                  "cell-bank_name_en": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.bank_manager_bank.bank_name_en), 1)
                  ]),
                  "cell-bank_manager_bank_number": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, [
                      _createTextVNode(" *" + _toDisplayString(item.bank_manager_bank_number.substr(
                      item.bank_manager_bank_number.length - 4
                    )) + " ", 1),
                      (item.bank_manager_default_bank == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _hoisted_10))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  "cell-bank_manager_customer_name": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.bank_manager_customer_name), 1)
                  ]),
                  "cell-bank_manager_status": _withCtx(({ row: item }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                    item.bank_manager_status == 1
                      ? 'badge_status--active'
                      : item.bank_manager_status == 2
                      ? 'badge_status--inactive'
                      : item.bank_manager_status == 3
                      ? 'badge_status--reject'
                      : item.bank_manager_status == 4
                      ? 'badge_status--delete'
                      : null,
                  ])
                    }, _toDisplayString(item.bank_manager_status == 1
                      ? "PENDING"
                      : item.bank_manager_status == 2
                      ? "APPROVE"
                      : item.bank_manager_status == 3
                      ? "REJECT"
                      : item.bank_manager_status == 4
                      ? "DELETE"
                      : null), 3)
                  ]),
                  "cell-actions": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_router_link, {
                        to: `/management/feature-bank/${item.bank_manager_id}`,
                        style: {"padding":"2px 10px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_11
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("span", null, [
                      _createElementVNode("i", {
                        class: "fa fa-trash",
                        onClick: ($event: any) => (_ctx.Popupdelete(item.bank_manager_id)),
                        style: {"cursor":"pointer"}
                      }, null, 8, _hoisted_12)
                    ])
                  ]),
                  _: 1
                }, 8, ["table-header", "table-data", "currentPage", "rowsPerPage"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.imgPopup,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.imgPopup) = $event)),
      width: "30%",
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_14, [
          _createVNode(_component_el_button, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imgPopup = false)),
            style: {"color":"red"}
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toDelete(_ctx.deleteData))),
            style: {"background-color":"#fddf00","color":"black"}
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_13
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}